import { Link, useLocation } from "react-router-dom";
import { Home as HomeIcon, Wallet } from "lucide-react";
import "./partnerWorkspace.css";

const COPY = {
  projects: { title: "Projects", body: "The full projects list is coming in a later phase. Your active projects are already visible on Home." },
  requests: { title: "Requests", body: "Reviewing and responding to requests is coming in a later phase." },
  "rate-card": { title: "Rate Card", body: "Rate card management — viewing approved rates and proposing changes — is coming in a later phase." },
  messages: { title: "Messages", body: "Messaging with your NJM team is coming in a later phase." },
  profile: { title: "Profile", body: "A dedicated profile page is coming in a later phase. You can already update your company logo from the sidebar or topbar." },
};

/** Shared "part of the same NJM workspace" placeholder — per the design bundle's own
 * instruction ("only Home and Rate Card are fully designed... build real screens later"), and
 * per the founder's explicit PP1 scope (Rate Card is PP2, not built this phase either). */
export default function PartnerWorkspacePlaceholder() {
  const location = useLocation();
  const segment = location.pathname.split("/")[2] || "projects";
  const copy = COPY[segment] || COPY.projects;

  return (
    <div className="max-w-[720px] mx-auto px-8 py-20 text-center pw-enter" data-testid="partner-workspace-placeholder-page">
      <div className="h-14 w-14 rounded-2xl mx-auto mb-6 flex items-center justify-center" style={{ background: "var(--pw-nav-active-tint)" }}>
        <Wallet className="h-6 w-6" style={{ color: "var(--pw-pending-text)" }} />
      </div>
      <h1 className="pw-display text-[26px] mb-3">{copy.title}</h1>
      <p className="text-[14.5px] mb-8" style={{ color: "var(--pw-text-secondary)" }}>{copy.body}</p>
      <Link to="/partner-portal/home" className="pw-btn-primary inline-flex items-center gap-2 px-5 py-2.5 text-[13px]" data-testid="partner-workspace-placeholder-home-cta">
        <HomeIcon className="h-3.5 w-3.5" /> Back to Home
      </Link>
    </div>
  );
}
